import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, checkoutSuccess, checkoutFailure } from '../../actions/billing/checkout';
import { fetchRequest as fetchSnapshot } from '../../actions/billing/snapshot';
import { fetchRequest as fetchSubscription } from '../../actions/billing/subscription';
import { fetchRequest as fetchBalance } from '../../actions/billing/balance';
import { fetchRequest as fetchSettingsPublic } from '../../actions/settings/public';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process(action) {
  try {
    const response = yield call(
      axios.post,
      `${config.API_URL}/billing/checkout-session`,
      action.payload || {},
      { headers: getLocalUser() },
    );
    const data = response.data?.data ?? response.data;
    yield put(checkoutSuccess(data));
    // Auto-redirect into Stripe. Falling back to the FE rendering the
    // URL as a manual link if window navigation is blocked (e.g.
    // popup-blocker scenarios; not the common path).
    if (data && data.url && typeof window !== 'undefined') {
      window.location.assign(data.url);
    } else {
      // No redirect URL — the backend applied the change directly
      // (simulated checkout when Stripe isn't configured). Refresh the
      // billing surface so the new plan, balance, and subscription
      // banners reflect the change immediately. An org-tier upgrade
      // also PROVISIONS the user's organization and rolls their
      // balance into it (billing owner flips user -> org), so the
      // viewer's org memberships must be refetched too — the billing
      // role gate and every org affordance read them.
      yield put(fetchSnapshot());
      yield put(fetchSubscription());
      yield put(fetchBalance());
      yield put(fetchSettingsPublic());
    }
  } catch (error) {
    yield put(Error(error));
    yield put(checkoutFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
